import React from 'react';
import './Table.css';

const Table = ({
  columns,
  data,
  isLoading = false,
  loadingText = 'Loading data…',
  placeholder = 'No data',
  renderRowActions,
  renderCell,
}) => {
  const colSpan = columns.length + (renderRowActions ? 1 : 0);

  return (
    <div className="table-container">
      <table className="app-table">
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i}>{col}</th>
            ))}
            {renderRowActions && <th></th>}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={colSpan} className="placeholder loading">
                {loadingText}
              </td>
            </tr>
          ) : data && data.length > 0 ? (
            data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <td key={colIndex}>
                    {renderCell ? renderCell(col, row, rowIndex) : row[col]}
                  </td>
                ))}
                {renderRowActions && <td>{renderRowActions(rowIndex)}</td>}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={colSpan} className="placeholder">
                {placeholder}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
